var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 0.75H9.56066L13.75 4.93934V15.75C13.75 16.5784 13.0784 17.25 12.25 17.25H1.75C0.921573 17.25 0.25 16.5784 0.25 15.75V2.25C0.25 1.42157 0.921573 0.75 1.75 0.75ZM7.75 2.25H1.75V15.75H12.25V6.75H9.25C8.42157 6.75 7.75 6.07843 7.75 5.25V2.25ZM9.25 2.56066V5.25H11.9393L9.25 2.56066ZM4 12.75V11.25H8.5V12.75H4ZM4 8.25V9.75H10V8.25H4Z",
    fill: "#FC6716"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.cc43e3b2.svg";
export { ForwardRef as ReactComponent };